import { render, staticRenderFns } from "./IntegrationBanner.vue?vue&type=template&id=72f70192&scoped=true&"
import script from "./IntegrationBanner.vue?vue&type=script&lang=js&"
export * from "./IntegrationBanner.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationBanner.vue?vue&type=style&index=0&id=72f70192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f70192",
  null
  
)

export default component.exports